import { FilterTypeKey, FilterType, INumberFilter, IStringFilter, IEnumFilter } from '../../components/filters-menu/filters';

export const bidderChangesLogsFilters = new Map<FilterTypeKey, FilterType>([
	[
		'numberFilters',
		{
			campaign_id: { columnName: 'Campaign ID', cellKey: 'campaign_id' },
		} as INumberFilter,
	],
	[
		'stringFilters',
		{
			user_email: { columnName: 'User Email', cellKey: 'user_email' },
		} as IStringFilter,
	],
	[
		'enumFilters',
		{
			type: {
				columnName: 'Type',
				cellKey: 'type',
				enumOptions: [
					{ value: 'CLONE_CAMPAIGN', label: 'Clone Campaign' },
					{ value: 'CREATE_CAMPAIGN', label: 'Create Campaign' },
					{ value: 'UPLOAD_CAMPAIGN_ISPS', label: 'Upload Campaign Isps' },
					{ value: 'UPDATE_CAMPAIGN_PROPERTIES', label: 'Update Campaign Properties' },
					{ value: 'UPLOAD_CAMPAIGN_DOMAINS', label: 'Upload Campaign Domains' },
					{ value: 'UPLOAD_CAMPAIGN_SUBIDS', label: 'Upload Campaign SUBIDS' },
					{ value: 'UPDATE_DOMAIN_STATUS_LIMIT', label: 'Update Domain Status Limit' },
					{ value: 'UPDATE_TARGET', label: 'Update Target' },
					{ value: 'UPDATE_TARGET_LINK', label: 'Update Target Link' },
					{ value: 'UPDATE_TARGET_LINK_CID', label: 'Update Target Link CID' },
					{ value: 'UPDATE_STRATEGY_PARAMETER', label: 'Update Strategy Parameter' },
					{ value: 'UPDATE_PUBLISHER_WHITE_LIST', label: 'Update Publisher White List' },
				],
				deletable: true,
			},
		} as IEnumFilter,
	],
]);
